import { HandlerBase } from "../../shared/handler/abstract/handler-base";
import $ from 'jquery'

export class LoginHandler extends HandlerBase {

    constructor() {
        super()
    }

    init() {
        this._initControls();
    }

    _initControls() {
        $("#LogIn").off("click");
        $("#LogIn").on("click", this.onRegularLoginForm);

        $("#external-login").off("click")
        $("#external-login").on("click", this.onExternalLoginForm);
    }

    /**
     * 
     * @param e {Event}
     * */
    onRegularLoginForm(e) {
        e.preventDefault()

        let formSelector = "[data-name=login-data]";
        let validator = $(formSelector).kendoValidator({ validateOnBlur: false }).data("kendoValidator");
        let isValid = validator.validate();

        if (!isValid) {
            return;
        }

        kendo.ui.progress($("body"), true);
        $(formSelector).submit();
    }

    /**
     * 
     * @param e {Event}
     * */
    onExternalLoginForm(e) {
        /** @type {HTMLButtonElement} */
        e.preventDefault()

        let buttonElement = e.currentTarget

        let authSchema = buttonElement.getAttribute("data-schema");
        let externalAuth = buttonElement.getAttribute("data-externalAuth");

        $("#ExternalAuth").val(externalAuth)
        $("#ExternalAuthSchema").val(authSchema)

        $("[data-name=login-external-form]").submit()
    }

}

